/**
 * 图片向后循环
 * @author {morgan}
 * @param {用于展示的数组} playerArr
 * @param {全部对象的数组} rulerArr
 * @param {用于比对的键值} keyName
 */
export function backLoop(playerArr, rulerArr, keyName) {
  let ruleLen = rulerArr.length;
  if (playerArr[0][keyName] === rulerArr[0][keyName]) {
    playerArr.pop();
    playerArr.unshift(rulerArr[ruleLen - 1]);
  } else {
    for (let g = 0; g < ruleLen; g++) {
      if (playerArr[0][keyName] === rulerArr[g][keyName]) {
        playerArr.pop();
        playerArr.unshift(rulerArr[g - 1]);
        break;
      }
    }
  }
  return playerArr;
}

/**
 * 图片向前循环
 * @author {morgan}
 * @param {用于展示的数组} playerArr
 * @param {全部对象的数组} rulerArr
 * @param {用于比对的键值} keyName
 */
export function forwardLoop(playerArr, rulerArr, keyName) {
  let playLen = playerArr.length;
  let ruleLen = rulerArr.length;
  if (playerArr[playLen - 1][keyName] === rulerArr[ruleLen - 1][keyName]) {
    playerArr.shift();
    playerArr.push(rulerArr[0]);
  } else {
    for (let q = 0; q < ruleLen; q++) {
      if (playerArr[playLen - 1][keyName] === rulerArr[q][keyName]) {
        playerArr.shift();
        playerArr.push(rulerArr[q + 1]);
        break;
      }
    }
  }
  return playerArr;
}



// WEBPACK FOOTER //
// ./src/common/util/pictureLoop.js